import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { RouterContext, history } from './Hooks';
import { currentPath, requestIdleCallback, cancelIdleCallback } from './Utils';
const RouterProps = {
	children: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.arrayOf(PropTypes.element),
	]),
	scrollRestoration: PropTypes.oneOf(['auto', 'manual']),
	legacy: PropTypes.bool,
	onUpdate: PropTypes.func,
};

const RouterDefaults = {
	scrollRestoration: 'auto', 
	legacy: false
}

export const Router = ({ children, scrollRestoration, legacy, onUpdate }) => {
	const [state, setState] = useState({
		url: currentPath(legacy).substr(legacy ? 2 : 0),
		prevUrl: null,
		matched: false,
		isNoMatched: false,
		initial: true,
		legacy,
		onUpdate
	});
	
	useEffect(() => {
		if (history) {
			if ('scrollRestoration' in history) {
				history.scrollRestoration = scrollRestoration;
			}

			const replaceLoadedUrl = currentPath(legacy);

			history.replaceState({}, null, replaceLoadedUrl);
		}

		window.addEventListener(
			'popstate',
			(e) => { 
				// to prevent not Link anchors
				if(e.state === null) return;
				const popUrl = currentPath(legacy)
				setState(prev => ({
					...prev, 
					url: legacy ? popUrl.substr(2) : popUrl, 
					prevUrl: prev.url, 
					matched: false, 
					isNoMatched: false 
				}));
			},
			false
		);
	}, [scrollRestoration, legacy]);

	useEffect(() => {
		if (state.matched || state.isNoMatched) return;
		const cleanup = requestIdleCallback(() => setState((prev) => ({ ...prev, isNoMatched: true })));
		return () => cancelIdleCallback(cleanup);
	}, [state]);

	useEffect(() => {
		typeof state.onUpdate === 'function' 
			&& state.url !== state.prevUrl
			&& (state.matched || state.isNoMatched)
			&& state.onUpdate.call(null, {
				url: state.url, 
				matched: state.matched,
				initial: state.initial,
				prevUrl: state.prevUrl
			})
	}, [state])

	const provide = {
		state,
		setState,
	};
	return (
		<RouterContext.Provider value={provide}>{children}</RouterContext.Provider>
	);
};

Router.propTypes = RouterProps;
Router.defaultProps = RouterDefaults;
